/* rb-m-pdp.js -- product pages. Phone only, needs window.RBM.
   Gallery fit + dots + swipe repair, size grid, size-chart line, final-sale
   notice, buy-box order. The sticky Add to cart is the theme's own
   (snippets/pdp-mobile-atc.liquid) -- see pdp-stickybar below. */
(function () {
  'use strict';
  if (!window.RBM) return;

  /* ---- final sale notice above the button -----------------------------------
     The theme renders .rooster-final-sale AFTER Add to cart and Buy with
     Shop, inside the same form. "No returns or exchanges" is a condition of
     the purchase and belongs before the control that makes it. Same form,
     same node -- just earlier. */
  RBM.onMobile('pdp-finalsale', function () {
    var note = document.querySelector('.product-form .rooster-final-sale');
    var add = document.querySelector('button[name="add"]');
    if (!note || !add || note.classList.contains('rbm-lifted')) return;
    var anchor = add.closest('.product-form__controls, .product-form__buttons') || add;
    anchor.parentNode.insertBefore(note, anchor);
    note.classList.add('rbm-lifted');
  });

  /* ---- gallery: crop only what can be cropped + dots ------------------------
     rb-m-pdp.css draws every photo in a 10:11 box. object-fit:cover trims
     4.5% off each side of a square, which is exactly right when the model
     stands in the middle of a white field and exactly wrong for a hat or a
     shoe that runs to the edges.

     Scanned 2026-09-15: 9,237 gallery images, 99.3% square. Of 1,902 white-
     background hero images, 302 (16%) have product inside the outer 4.5% --
     American Needle, Seager, Melin, Branded Bills, Astorflex, Veja. So the
     decision is made per image, from its pixels: the loaded <img> is drawn
     to an 80px canvas (the CDN is same-origin) and the outer 5% columns on
     each side are checked for being one flat colour. Flat -> cover. Anything
     else -- content at the edge, a landscape or portrait frame, a tainted
     canvas -- gets contain, which is never wrong, only 10% smaller.

     The dots replace the thumbnail strip and drive the theme's own (hidden)
     thumbnail buttons, so there is no second slider to keep in step. */
  RBM.onMobile('pdp-gallery', function () {
    var gal = document.querySelector('.product-single__media--mobile-slider .media-gallery--large');
    if (!gal || gal.querySelector('.rbm-gdots')) return;

    function sidesClear(img) {
      var N = 80, strip = 4;                       /* 4 of 80 columns = 5% */
      try {
        var cv = document.createElement('canvas');
        cv.width = N; cv.height = N;
        var cx = cv.getContext('2d');
        cx.drawImage(img, 0, 0, N, N);
        var d = cx.getImageData(0, 0, N, N).data;
        for (var side = 0; side < 2; side++) {
          var ref = null;
          for (var y = 0; y < N; y++) {
            for (var c = 0; c < strip; c++) {
              var x = side ? N - 1 - c : c;
              var i = (y * N + x) * 4;
              if (!ref) { ref = [d[i], d[i + 1], d[i + 2]]; continue; }
              if (Math.abs(d[i] - ref[0]) + Math.abs(d[i + 1] - ref[1]) + Math.abs(d[i + 2] - ref[2]) > 60) return false;
            }
          }
        }
        return true;
      } catch (e) {
        return false;                              /* cross-origin: do not crop */
      }
    }

    function judge(img) {
      if (!img.naturalWidth) return;
      var ratio = img.naturalWidth / img.naturalHeight;
      var square = ratio >= 0.9 && ratio <= 1.05;
      img.classList.toggle('rbm-fit', !(square && sidesClear(img)));
    }
    Array.prototype.forEach.call(gal.querySelectorAll('.media-gallery__image'), function (img) {
      if (img.complete) judge(img); else img.addEventListener('load', function () { judge(img); }, { once: true });
    });

    /* Swipe tuning. Measured with synthetic touches: slick ships
       touchThreshold:5, which makes the minimum swipe listWidth/5 = 79px --
       a 40px or 60px flick did nothing -- and waitForAnimate:true, which
       drops any swipe that lands during the 300ms slide animation, so two
       quick flicks move one slide. Both options are read by slick at swipe
       time, so they can be set on the live instance without a re-init.
       12 -> a 33px flick counts. */
    try {
      var $ = window.jQuery;
      var slider = gal.querySelector('.js-product-slider');
      if ($ && slider && $(slider).hasClass('slick-initialized')) {
        $(slider).slick('slickSetOption', {
          touchThreshold: 12,
          waitForAnimate: false,
          speed: 240
        }, false);

        /* THE REAL DROP. slick.swipeMove gives up the whole gesture if the
           finger has moved more than 4px VERTICALLY before slick has decided
           the swipe is horizontal (it sets _.scrolling = true and returns).
           A thumb arcs, so the first move event of a perfectly good sideways
           swipe often carries 5-15px of drift -- reproduced: 100px across
           with 48px down was thrown away. That code cannot be edited, so
           the same touches are watched here and, on release, a swipe that
           was clearly horizontal and that slick did not act on is turned
           into slickNext / slickPrev. slick's own touchend handler is bound
           earlier on the same element and runs first, so when it does take
           the swipe, currentSlide has already moved and this does nothing. */
        var list = slider.querySelector('.slick-list') || slider;
        var start = null, before = -1;
        function inst() { try { return $(slider).slick('getSlick'); } catch (e) { return null; } }
        list.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { start = null; return; }
          var s = inst();
          before = s ? s.currentSlide : -1;
          start = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }, { passive: true });
        list.addEventListener('touchend', function (e) {
          if (!start || e.changedTouches.length !== 1) return;
          var dx = e.changedTouches[0].clientX - start.x;
          var dy = e.changedTouches[0].clientY - start.y;
          start = null;
          if (Math.abs(dx) < 33 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          var s = inst();
          if (!s || before < 0 || s.currentSlide !== before) return;   /* slick took it */
          /* Explicit target, not slickPrev/Next: slickPrev on slide 0 of a
             non-looping slider was measured landing on slide 3. */
          var target = dx < 0 ? before + 1 : before - 1;
          if (target < 0 || target >= s.slideCount) return;
          $(slider).slick('slickGoTo', target);
        }, { passive: true });
      }
    } catch (e) { /* slick absent or older API: theme defaults stand */ }

    var thumbs = gal.querySelectorAll('.thumbnail-list__item');
    if (thumbs.length < 2) return;
    var wrap = document.createElement('div');
    wrap.className = 'rbm-gdots';
    wrap.setAttribute('role', 'tablist');
    wrap.setAttribute('aria-label', 'Product photos');
    var dots = [], count = null;
    if (thumbs.length <= 8) {
      Array.prototype.forEach.call(thumbs, function (li, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + thumbs.length);
        d.addEventListener('click', function () {
          var b = li.querySelector('button');
          if (b) b.click();
        });
        wrap.appendChild(d);
        dots.push(d);
      });
    } else {
      count = document.createElement('span');
      count.className = 'rbm-gcount';
      wrap.appendChild(count);
    }
    gal.appendChild(wrap);

    function paint() {
      var on = 0;
      Array.prototype.forEach.call(thumbs, function (li, i) {
        if (li.classList.contains('thumbnail-list__item--active')) on = i;
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-on', i === on);
        d.setAttribute('aria-selected', i === on ? 'true' : 'false');
      });
      if (count) count.textContent = (on + 1) + ' / ' + thumbs.length;
    }
    paint();
    if (window.MutationObserver) {
      new MutationObserver(paint).observe(thumbs[0].parentNode, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  });

  /* ---- size grid columns -------------------------------------------------
     Reads the longest label at its natural width, then picks the most
     columns (capped at the count, and at 6) that let it fit in one cell.
     Set on the fieldset as --rbm-cols; the layout itself is CSS. */
  function sizeGrid() {
    var W = document.documentElement.clientWidth - 24;      /* inside the gutters */
    Array.prototype.forEach.call(document.querySelectorAll('.product-form__swatch'), function (fs) {
      var items = fs.querySelectorAll('.product-form__swatch__item--button');
      if (items.length < 2 || items.length !== fs.querySelectorAll('.product-form__swatch__item').length) return;
      if (fs.classList.contains('rbm-sizes')) return;
      var longest = 0;
      Array.prototype.forEach.call(items, function (it) {
        var lab = it.querySelector('.product-form__swatch__label') || it;
        var cs = getComputedStyle(lab);
        var text = lab.getBoundingClientRect().width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        /* the grid renders at 13.5px; the theme's inline label is 12.96px */
        text = text * (13.5 / (parseFloat(cs.fontSize) || 13.5));
        if (text > longest) longest = text;
      });
      var need = longest + 14;                                /* 6px padding a side + slack */
      var n = items.length;
      var cols = Math.min(n, 6);
      while (cols > 2 && (W - 8 * (cols - 1)) / cols < need) cols--;
      /* When it has to wrap, balance the rows rather than fill and orphan:
         7 waist sizes become 4 + 3, not 6 + 1; five alphas 3 + 2, not 4 + 1. */
      if (n > cols) cols = Math.ceil(n / Math.ceil(n / cols));
      fs.style.setProperty('--rbm-cols', cols);
      fs.classList.add('rbm-sizes');
    });
  }

  /* ---- size chart link on one line ----------------------------------------
     Tries the snippet's own text first, then drops the brand name. The link
     is a centred flex box, so an overflowing line spills BOTH ways and
     scrollWidth never grows -- the text itself is measured with a Range. */
  function sizeLink() {
    var a = document.querySelector('.rb-psg__mlink a');
    if (!a || a.dataset.rbmFit) return;
    a.dataset.rbmFit = '1';
    var cs = getComputedStyle(a);
    var room = a.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var range = document.createRange();
    range.selectNodeContents(a);
    if (range.getBoundingClientRect().width <= room) return;
    var full = a.textContent.replace(/\s+/g, ' ').trim();
    var m = full.match(/^(.*?)\s*size chart\s*(.*)$/i);
    if (!m) return;
    a.setAttribute('title', full);
    a.textContent = 'Size chart ' + m[2];
  }

  RBM.onMobile('pdp-sizes', function () {
    sizeGrid();
    sizeLink();
    var section = document.querySelector('.js-section__product-single');
    if (section && RBM.onSectionSwap) {
      RBM.onSectionSwap(section, function () { sizeGrid(); sizeLink(); });
    }
  });

  /* ---- denim sizes: waist -> inseam, and nothing pre-picked ------------------
     (Mark, 22 Sep: "do 3 and 1".)

     WAIST -> INSEAM. A denim size fieldset is 18 cells of "29x32 30x30 ...",
     11 of them struck through on Zach: two decisions crammed into one grid.
     Where every size value is NNxNN the theme's cells are hidden (kept in
     the DOM -- they ARE the variant state) and two rows are drawn from them:
     Waist chips, struck only when that waist has no length in stock, then
     the chosen waist's Inseam chips. Tapping an inseam clicks the theme's own
     radio, so price, stock note, sticky bar and URL update exactly as before.
     Availability is read from the theme's own input.disabled / .is-disabled,
     which product-interactive-options.js keeps current per colour.

     NOTHING PRE-PICKED. The theme lands on Zach with 32x30 already selected
     -- the sticky bar reads "Ice Chalk Twill / 32x30" and one tap on Add
     buys jeans nobody chose. The theme's internal variant is left alone (its
     option logic needs one); the PAGE shows no size chosen: no highlighted
     cell, Add to cart reads "Select size" and is inert, Buy with Shop is
     hidden, and the sticky bar's button says "Select size" and scrolls to the
     sizes. The first size tap clears all of that. Skipped when the URL
     carries ?size= or ?variant= -- the theme passes size across wash pages,
     so a shopper who picked 33x32 on one wash keeps it on the next. */
  function isDenimFieldset(fs) {
    var items = fs.querySelectorAll('.product-form__swatch__item--button');
    if (items.length < 4) return false;
    return Array.prototype.every.call(items, function (it) { return /^\d{2}\s*x\s*\d{2}$/i.test((it.getAttribute('data-value') || '').trim()); });
  }

  function denimPicker(fs) {
    var items = Array.prototype.slice.call(fs.querySelectorAll('.product-form__swatch__item--button'));
    var rows = items.map(function (it) {
      var v = (it.getAttribute('data-value') || '').trim().split(/x/i);
      var input = it.querySelector('input');
      return { w: v[0].trim(), l: v[1].trim(), input: input, item: it,
        ok: !(input && input.disabled) && !(it.querySelector('label') || {}).classList.contains('is-disabled'),
        checked: !!(input && input.checked) };
    });
    var waists = []; rows.forEach(function (r) { if (waists.indexOf(r.w) < 0) waists.push(r.w); }); waists.sort(function (a, b) { return a - b; });
    var box = fs.querySelector('.rbm-denim') || document.createElement('div');
    box.className = 'rbm-denim';
    var picked = document.body.classList.contains('rbm-unpicked') ? null : (rows.filter(function (r) { return r.checked; })[0] || null);
    var curW = box.dataset.w || (picked ? picked.w : '');
    if (curW && waists.indexOf(curW) < 0) curW = '';
    box.dataset.w = curW;

    box.innerHTML =
      '<div class="rbm-denim__lab">Waist</div>' +
      '<div class="rbm-denim__row">' + waists.map(function (w) {
        var any = rows.some(function (r) { return r.w === w && r.ok; });
        return '<button type="button" class="rbm-denim__chip' + (w === curW ? ' is-on' : '') + (any ? '' : ' is-out') + '" data-w="' + w + '">' + w + '</button>';
      }).join('') + '</div>' +
      '<div class="rbm-denim__lab">Inseam' + (curW ? '' : ' <span>pick a waist first</span>') + '</div>' +
      '<div class="rbm-denim__row rbm-denim__row--l">' + (curW ? rows.filter(function (r) { return r.w === curW; }).sort(function (a, b) { return a.l - b.l; }).map(function (r) {
        return '<button type="button" class="rbm-denim__chip' + (picked && picked.w === r.w && picked.l === r.l ? ' is-on' : '') + (r.ok ? '' : ' is-out') + '" data-w="' + r.w + '" data-l="' + r.l + '">' + r.l + '</button>';
      }).join('') : '<span class="rbm-denim__hint">Lengths show once you choose a waist</span>') + '</div>';
    if (!box.parentNode) fs.appendChild(box);
    fs.classList.add('rbm-denim-on');
  }

  /* Named so rb-d-pdp.js can register the same behaviour above 767px
     (Mark, 23 Sep: waist -> inseam and no pre-picked size on desktop too).
     Guarded per fieldset, so it initialises once whichever side runs first. */
  function pdpDenim() {
    var fs = Array.prototype.filter.call(document.querySelectorAll('.product-form__swatch'), isDenimFieldset)[0];
    if (!fs || fs.dataset.rbmDenim) return;
    fs.dataset.rbmDenim = '1';

    /* nothing pre-picked, unless the shopper already chose */
    var q = location.search;
    if (!/[?&](size|variant)=/.test(q)) document.body.classList.add('rbm-unpicked');

    denimPicker(fs);
    /* product-interactive-options.js sets the disabled/is-disabled state a
       beat after DOMContentLoaded; the strikes were missing on first paint. */
    setTimeout(function () { denimPicker(fs); }, 400);
    window.addEventListener('load', function () { setTimeout(function () { denimPicker(fs); }, 100); });

    fs.addEventListener('click', function (e) {
      var chip = e.target.closest('.rbm-denim__chip'); if (!chip) return;
      e.preventDefault();
      var box = fs.querySelector('.rbm-denim');
      if (!chip.hasAttribute('data-l')) {            /* waist */
        box.dataset.w = chip.getAttribute('data-w');
        denimPicker(fs);
        return;
      }
      var val = chip.getAttribute('data-w') + 'x' + chip.getAttribute('data-l');
      var item = Array.prototype.filter.call(fs.querySelectorAll('.product-form__swatch__item--button'), function (it) { return (it.getAttribute('data-value') || '').replace(/\s/g, '') === val; })[0];
      var input = item && item.querySelector('input');
      if (!input) return;
      document.body.classList.remove('rbm-unpicked');
      input.click();                                  /* the theme takes it from here */
      setTimeout(function () { denimPicker(fs); }, 60);
    });

    /* any other route to a size (sticky bar select, theme code) also counts */
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('change', function () { document.body.classList.remove('rbm-unpicked'); setTimeout(function () { denimPicker(fs); }, 60); });

    /* the sticky bar: "Select size" until a size is picked, tap scrolls up */
    var bar = document.querySelector('.pdp-mobile-atc');
    if (bar) {
      var lab = bar.querySelector('[data-pdp-mobile-atc-label]');
      var sub = bar.querySelector('[data-pdp-mobile-atc-submit]');
      function paintBar() {
        if (!lab) return;
        if (document.body.classList.contains('rbm-unpicked')) { if (!lab.dataset.rbmKeep) lab.dataset.rbmKeep = lab.textContent; lab.textContent = 'Select size'; }
        else if (lab.dataset.rbmKeep && lab.textContent === 'Select size') { lab.textContent = lab.dataset.rbmKeep; delete lab.dataset.rbmKeep; }
      }
      paintBar();
      if (window.MutationObserver) {
        new MutationObserver(paintBar).observe(document.body, { attributes: true, attributeFilter: ['class'] });
        if (lab) new MutationObserver(function () { if (document.body.classList.contains('rbm-unpicked') && lab.textContent !== 'Select size') { lab.dataset.rbmKeep = lab.textContent; lab.textContent = 'Select size'; } }).observe(lab, { childList: true, characterData: true, subtree: true });
      }
      if (sub) sub.addEventListener('click', function (e) {
        if (!document.body.classList.contains('rbm-unpicked')) return;
        e.preventDefault(); e.stopImmediatePropagation();
        fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, true);
    }
    /* the page's own Add to cart while unpicked: scroll to the sizes */
    var atc = form && form.querySelector('[name="add"]');
    if (atc) atc.addEventListener('click', function (e) {
      if (!document.body.classList.contains('rbm-unpicked')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, true);
  }
  RBM.onMobile('pdp-denim', pdpDenim);
  RBM.pdpShared = { pdpDenim: pdpDenim, isDenimFieldset: isDenimFieldset };

  /* ---- sticky add to cart: the theme's own bar -------------------------------
     snippets/pdp-mobile-atc.liquid + assets/pdp-mobile-atc.js already give
     phones a fixed bottom bar with a colour/size select and "Add -- $price",
     shown once the buy-buttons block leaves the viewport. It was verified in
     both directions on 2026-09-15 (select -> page swatches, price, URL and
     stock note; page swatch -> select) and it submits through the theme's
     real Add to cart button, so cart behaviour is identical.

     An earlier build of this file added a SECOND bar on top of it (z 80 over
     its z 50) -- invisible in every screenshot because the Shopify preview
     bar covers the bottom 75px. Removed. The only thing left to do for the
     theme's bar is to mirror its visibility onto <body>, which is the hook
     rb-m-core.css uses to lift the Smile launcher clear of a pinned bar. */
  RBM.onMobile('pdp-stickybar', function () {
    var bar = document.querySelector('.pdp-mobile-atc');
    if (!bar || bar.dataset.rbmHooked) return;
    bar.dataset.rbmHooked = '1';
    function mirror() {
      document.body.classList.toggle('rbm-has-stickybar', bar.classList.contains('is-visible'));
    }
    mirror();
    if (window.MutationObserver) {
      new MutationObserver(mirror).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
  });

  /* ---- buy box order below the button ---------------------------------------
     Measured (comfort-terry-shirt-jacket-taupe): after Add to cart came store
     availability 255px, "Arrives by" 66, four trust bullets 156, Shop Pay 48
     and the email-list note 35 -- ~560px of logistics -- and the description
     (fabric, fit, what the thing is) started at y~1906, nearly three screens
     down. Nothing is removed; the blocks are put in the order a buyer reads:

       Add to cart -> Arrives by -> Availability -> Description -> trust ->
       Shipping & returns

     "Arrives by" stays next to the button because it is part of the buying
     decision, and Availability stays above the description (Mark, 15 Sep):
     "In stock -- try it on today" at two Arizona stores is a reason to buy,
     not logistics. The nodes are MOVED, not cloned: pdp-stores' inline script
     already ran and holds its element references, and the description
     accordion's <details> keep their state. Idempotent via .rbm-ordered. */
  RBM.onMobile('pdp-order', function () {
    var box = document.querySelector('.product-single__box');
    if (!box || box.classList.contains('rbm-ordered')) return;
    var buy = box.querySelector('.product-single__box__block--buy_buttons');
    var desc = box.querySelector('.product-single__box__block--description');
    if (!buy || !desc) return;
    var deliveryEl = box.querySelector('.pdp-delivery');
    var trustEl = box.querySelector('.pdp-trust');
    var delivery = deliveryEl && deliveryEl.closest('.product-single__box__block');
    var trust = trustEl && trustEl.closest('.product-single__box__block');
    var stores = box.querySelector('.pdp-stores');

    var after = buy;
    function place(node) {
      if (!node || node === after) return;
      after.parentNode.insertBefore(node, after.nextSibling);
      after = node;
    }
    place(delivery);
    place(stores);
    place(desc);
    place(trust);
    box.classList.add('rbm-ordered');
  });
})();
